/**
 * Contain the Style for the Borrows View
 */

//ColorManager
import ColorManager from "./../managers/ColorManager";

export default {
    customTableCell: {
        borderBottom: "none",
        whiteSpace: "pre-wrap"
    },

    filterString: {
        padding: 0,
        textAlign: "center",
        width: "100%"
    },

    inputContainer: {
        width: "100%"
    },

    expansionPanelContainer: {
        display: "inherit",
        width: "100%"
    },

    toggleCell: {
        alignItems: "center",
        borderBottom: "none",
        display: "flex",
        justifyContent: "center"
    },

    greenIcon: {
        color: ColorManager.success
    },

    redIcon: {
        color: ColorManager.error
    },

    phoneButton: {
        textDecoration: "none"
    },

    phoneButtonFab: {
        backgroundColor: ColorManager.primaryColor,
        height: 30,
        minHeight: 30,
        width: 30
    },

    miniIcon: {
        height: 20,
        width: 20
    },

    rowDetail: {
        paddingBottom: "24px"
    }
};



// WEBPACK FOOTER //
// ./src/app/styles/Materials.ts